<template>
  <vz-card>
    <vz-loader :status-loader="orderStore.orderTotalPriceLoader || pageLoader" view-only/>

    <div class="vz-personal-order-total-card-item pt-30">
      <div class="vz-order-total-price-line mb-15">
        <div class="vz-order-total-price-line-service flex-align-items-center">
          <span class="text-h1 color-dark">Стоимость</span>
          <span class="vz-personal-order-total-card-item-buttons">
            <vz-order-print-button v-if="isNewOrder" title="Печать">
              <span class="vz-order-total-price-print">Печать</span>
            </vz-order-print-button>
            <vz-order-links-button v-if="isNewOrder" title="Ссылка">
              <span class="vz-order-total-price-links">Ссылка</span>
            </vz-order-links-button>
            <vz-button v-if="hasToggle" :icon-name="toggleIcon" rounded class="ml-5" @click="visible = !visible"/>
          </span>
        </div>
      </div>
    </div>

    <div v-if="orderStore.costDisabledReason" class="vz-personal-order-total-card-item">
      <vz-order-total-price-cost class="vz-order-total-price-line"/>
    </div>
    <template v-else>
      <div v-show="visible" class="vz-personal-order-total-card-item">
        <div v-for="(service, index) of orderStore.orderForm.services" :key="index"
             class="vz-order-total-price-line mb-15">
          <div class="vz-order-total-price-line-service">
            <span class="text-body color-dark" :title="service.title">{{ service.title }}
              <vz-tooltip-info
                v-if="service.description"
                :text="service.description"
              />
            </span>
            <span class="text-caption color-dark">{{ service.base }} {{ currencyMeasure }}</span>
          </div>
          <div v-if="service.discount && !isBonuses" class="vz-order-total-price-line-discount">
            <span class="text-caption color-info2">Скидка</span>
            <span class="text-caption color-info2">{{ service.discount }} {{ currencyMeasure }}</span>
          </div>
        </div>

        <div v-if="!isEdit || promocode" class="vz-order-total-price-line mb-20 flex-start">
          <div class="vz-order-total-price-line-service  flex-align-items-center">
            <label class="text-body color-dark mr-10 mb-0">Промокод</label>
            <vz-input
              v-model="promocode"
              :disabled="isEdit || !!isBonuses"
              :max-length="15"
              style="width: 122px;"
              class="mb-0 flex-align-self-start"
              @focus="onPromoCodeFocus"
              @blur="onPromoCodeBlur"
              @keydown.enter="onPromoCodeBlur"
            />
            <span class="text-caption color-dark ml-auto"> 0 {{ currencyMeasure }}</span>
          </div>
        </div>
      </div>
      <hr v-show="visible" class="vz-individual-order-delimeter dashed">
      <div class="vz-personal-order-total-card-item">
        <div
          v-if="!!isBonusModeActive"
          class="mb-20"
        >
          <vz-switcher
            v-model="isBonuses"
            :disabled="!!orderStore.orderForm.promocode"
            class="w-100 mb-10"
            :items="contractorTypes"
          />

          <nuxt-link
            v-if="isBonuses"
            :to="{ name: 'bonuses' }"
            target="_blank"
            class="text-decoration-underline"
          >
            Подробнее о бонусах
          </nuxt-link>
        </div>

        <template v-if="orderStore.orderForm.totalPrice?.total">
          <div v-if="orderStore.orderTotalPrice" v-show="visible" class="vz-order-total-price-line mb-10">
            <div class="vz-order-total-price-line-service">
              <span class="text-body color-dark">Всего</span>
              <span v-if="orderStore.orderTotalPrice.base" class="text-body color-dark">
              {{ orderStore.orderTotalPrice.base }} {{ currencyMeasure }}
            </span>
            </div>
          </div>

          <div
            v-if="orderStore.orderTotalPrice?.discount || !!isBonuses"
            v-show="visible"
            class="vz-order-total-price-line mb-15"
          >
            <div class="vz-order-total-price-line-service">
              <span class="text-body color-info2 flex flex-align-items-center">
                <span style="margin-right: 3px;">{{ !!isBonuses ? 'Бонусы' : 'Скидки' }}</span>
                <vz-tooltip-info>
                  <template #baloon>
                    <span v-if="!!isBonuses">Бонусы начисляются после приема груза на терминале отправления</span>
                    <span v-else>{{ orderStore.orderTotalPrice.action }}</span>
                  </template>
                </vz-tooltip-info>
              </span>

              <template v-if="!!isBonuses">
                <div class="vz-order-total-price-line-discount-bonus">
                  <span class="text-body color-info2">+{{ Math.abs(+orderStore.orderTotalPrice?.discount || isBonusModeActive || 0) }}</span>
                  <vz-icon
                    variant="primary"
                    size="12"
                    url="/svg/icon/vz-star.svg"
                    no-masked-icon
                  />
                </div>
              </template>
              <template v-else>
                <span class="text-body color-info2">{{ orderStore.orderTotalPrice.discount }} {{ currencyMeasure }}</span>
              </template>
            </div>
          </div>

          <div class="vz-order-total-price-line-discount mb-10">
            <vz-order-total-price-cost
              ref="orderTotalPriceCost"
              :is-show-price="!isAnotherPrice && !isLoadBlock"
              class="vz-order-total-price-line"
            />
          </div>

          <template v-if="isAnotherPrice || isLoadBlock">
            <vz-pup-button
              text-button="до Адреса"
              :total-price="`${(addressFinalPrice || '').toString()} ${orderTotalPriceCost?.currencyMeasure}`"
              :is-active="!isPickupPoint"
              @click="changeDirectionToAddress"
              :is-load-price="isLoadPupButton || orderStore.orderTotalPriceLoader || pageLoader"
              :is-load-block="isLoadBlock"
            >
              <template #icon>
                <vz-icon
                  class="vz-pup-icon-location"
                  url="/svg/location-new.svg"
                  size="24"
                  variant="default"
                />
              </template>
            </vz-pup-button>

            <vz-pup-button
              text-button="до ПВЗ Яндекса"
              :total-price="`${(yandexFinalPrice || '').toString()} ${orderTotalPriceCost?.currencyMeasure}`"
              :info="profitPupYandex > 0 ? `Выгоднее на ${profitPupYandex} ${orderTotalPriceCost?.currencyMeasure}` : ''"
              :is-active="isPickupPoint"
              :is-load-price="isLoadPupButton || orderStore.orderTotalPriceLoader || pageLoader"
              :is-load-block="isLoadBlock"
              @click="showMapModal"
            >
              <template #icon>
                <vz-icon
                  class="vz-pup-icon-yandex"
                  url="/svg/logo/yandex.svg"
                  size="20"
                  variant="default"
                />
              </template>
            </vz-pup-button>
          </template>

          <vz-add-promocode
            :is-disabled="!!isBonuses"
            @update-order="onSendForm"
          />

          <div v-if="hideCostHint" class="text-caption color-light mb-10">
            <b>Стоимость грузоперевозки может измениться</b> при:
            <div>- изменении габаритов или веса груза после замера на терминале;</div>
            <div>- редактировании дополнительных услуг.</div>
          </div>
        </template>
        <div v-else class="vz-orders-item-payment-blocked vz-orders-item-payment-status color-success mb-10">
          {{ orderStore.payerText }}
        </div>
        <slot name="buttons">
          <vz-order-total-price-get-btn
            class="vz-order-total-price-get-buttons pdf-order-section-hide"
            item-class="vz-order-total-price-get-buttons--custom-item"
            @get-price="onGetPrice"
            @send-form="onSendForm"
            @create-draft="onCreateDraft"
          />
        </slot>
      </div>
    </template>
  </vz-card>

  <client-only>
    <vz-map-select-modal
      ref="mapSelectModal"
      :location="destinationLocation"
      :pickup-point-guid="orderStore.orderForm.directions.destination.pickupPointGuid"
      :hide-switcher="true"
      terminal-purpose="to"
      direction-type="pickupPoint"
      @submit="onMapSubmit"
    />
  </client-only>
</template>

<script setup lang="ts">
import {useOrderStore} from '~/stores/order';
import VzOrderTotalPriceCost from '~/components/personal/order/vz-order-total-price-cost.vue';
import VzOrderTotalPriceGetBtn from '~/components/personal/order/vz-order-total-price-get-btn.vue';
import VzOrderPrintButton from '~/components/personal/order/buttons/vz-order-print-button.vue';
import VzOrderLinksButton from '~/components/personal/order/buttons/vz-order-links-button.vue';
import {useLayoutStore} from '~/stores/personal/layout';
import VzCard from '~/components/ui-kit/vz-card.vue';
import VzLoader from '~/components/ui-kit/vz-loader.vue';
import VzButton from '~/components/ui-kit/vz-button.vue';
import VzTooltipInfo from '~/components/ui-kit/vz-tooltip-info.vue';
import VzInput from '~/components/ui-kit/vz-input.vue';
import {toRefs} from "@vue/reactivity";
import VzMapSelectModal from "~/components/modals/vz-map-select-modal.vue";
import {Location, OrderDirectionType, SwitchItem} from "~/types/types";
import VzAddPromocode from "~/components/public/order/vz-add-promocode.vue";
import {getOrderPrice as getOrderPriceApi, getPickupPointList, getTimeTable} from "~/api/order";
import {pricePayload} from "~/common/objects";
import {deepCopyObject} from "~/common/functions";
import dayjs from "dayjs";
import VzPupButton from "~/components/personal/order/buttons/vz-pup-button.vue";
import {formatDate} from "~/common/date";
import VzSwitcher from "~/components/ui-kit/vz-switcher.vue";

const emit = defineEmits(['send-form', 'get-price', 'create-draft'])

const props = defineProps({
  hasToggle: {
    type: Boolean,
    default: true
  },
})

const contractorTypes = computed((): SwitchItem[] => [
  {
    title: 'Скидка',
    value: 0,
    icon: {
      url: '/svg/icon/vz-coin-ruble.svg',
      variant: 'white',
      size: 16
    },
    classItem: 'flex-row-reverse'
  },
  {
    title: 'Бонусы',
    value: orderStore.orderTotalPrice?.depositBonusFromDiscount || orderStore.orderTotalPrice?.savedBonusFromDiscount || null,
    icon: {
      url: '/svg/icon/vz-star.svg',
      variant: 'white',
      size: 16
    },
    classItem: 'flex-row-reverse'
  }
])

const orderStore = useOrderStore()
const {specialPupPvz, destinationLocation} = toRefs(useOrderStore())
const {pageLoader} = toRefs(useLayoutStore())
const mapSelectModal = ref()
const orderTotalPriceCost = ref()

const visible = ref(true)
const isLoadPupButton = ref(false)
const oldPromo = ref('')
const pupTotalPrice = ref(0)
const addressTotalPrice = ref(0)

const isBonusModeActive = computed(() => orderStore.orderForm.totalPrice?.depositBonusFromDiscount || orderStore.orderForm.totalPrice?.savedBonusFromDiscount)

const isBonuses = computed({
  get() {
    return orderStore.orderForm.depositBonusFromDiscount
  },
  set(value: any) {
    orderStore.orderForm.depositBonusFromDiscount = value
    emit('get-price', true)
  }
})

const promocode = computed({
  get() {
    return orderStore.orderForm.promocode
  },
  set(value: string) {
    orderStore.orderForm.promocode = value
  }
})

const hideCostHint = computed(() => {
  return !orderStore.orderForm?.meta?.taken
})

const isEdit = computed(() => {
  return !!useRoute().params.guid
})

const currency = computed(() => {
  return orderStore.orderForm?.currency
})

const isNewOrder = computed(() => {
  return !useRoute().params.guid
})

const currencyMeasure = computed(() => {
  return orderStore.orderPriceCurrency.currency
})

const toggleIcon = computed(() => {
  return visible.value ? 'chevron-up' : 'chevron-down'
})

const profitPupYandex = computed(() => {
  return (addressFinalPrice.value - yandexFinalPrice.value) || 0
})

const isPickupPoint = computed(() => {
  // если direction уже ПВЗ
  return (orderStore.orderForm.directions?.destination?.direction === 'pickupPoint')
})

const isTerminalDirection = computed(() => {
  return (orderStore.orderForm.directions?.destination?.direction === 'terminal')
})

const isLoadBlock = computed(() => {
  const pupYandexCount = +(orderStore.destinationLocation?.pup_count || 0)
  return !!(orderStore.destinationLocation.rcl_guid && pupYandexCount && (!pupTotalPrice.value && !addressTotalPrice.value))
})

const yandexPupPrice = computed(() => {
  const pupYandexCount = +(orderStore.destinationLocation?.pup_count || 0)
  const destinationLocationTerminals = +(orderStore.destinationLocation?.has_terminals || 0)

  // если Населенный пункт доставки где нет филиалов компании
  if (destinationLocationTerminals) {
    return
  }

  // если В населенном пункте доставки есть ПВЗ
  if (!pupYandexCount) {
    return
  }

  // если Габариты груза подходят под доставку в ПВЗ
  if (!specialPupPvz.value) {
    return
  }

  return true
})

function onSendForm() {
  emit('send-form')
}

function onGetPrice() {
  emit('get-price')
}

function onCreateDraft() {
  emit('create-draft')
}

function onPromoCodeBlur() {
  if ((oldPromo.value !== promocode.value && promocode.value.length <= 15) && (promocode.value.length <= 15 || promocode.value.length === 0)) {
    onGetPrice()
    oldPromo.value = promocode.value
  }
}

function onPromoCodeFocus() {
  oldPromo.value = promocode.value
}

async function onLocationChange(guid: string, location?: Location) {
  orderStore.orderForm.directions.destination.locationGuid = guid

  if (location) {
    orderStore.destinationLocation = location
    orderStore.orderForm.directions.destination.country = location.country || orderStore.orderForm.directions.destination.country
  }
}

function onMapSubmit(data: { address: string, direction: OrderDirectionType, location: string, terminal: string, pickupPoint: string, selectedLocation?: Location }) {
  orderStore.orderForm.directions.destination.direction = data.direction
  orderStore.orderForm.directions.destination.pickupPointGuid = data.pickupPoint
  onLocationChange(data.location, data.selectedLocation)
}

function showMapModal() {
  mapSelectModal.value?.show()
}

function changeDirectionToAddress() {
  orderStore.orderForm.directions.destination.direction = 'address'
}

const tempDestinationPickup = ref<any>({
  address: '',
  calendar: {
    date: '',
    fixedTime: false,
    from: '',
    terminalTime: '',
    to: ''
  },
  direction: '',
  locationGuid: '',
  networkAddressGuid: '',
  pickupPointGuid: '',
  terminalGuid: '',
  waitingTime: 30
})

const isAnotherPrice = computed(() => {
  return !!(yandexPupPrice.value && (pupTotalPrice.value || addressTotalPrice.value))
})

const addressFinalPrice = computed(() => {
  return isPickupPoint.value ? addressTotalPrice.value : orderTotalPriceCost.value?.totalPrice
})

const yandexFinalPrice = computed(() => {
  return isPickupPoint.value ? orderTotalPriceCost.value?.totalPrice : pupTotalPrice.value
})

async function yandexGetPrice() {
  try {
    const pickupPointsList = (await getPickupPointList('', orderStore.destinationLocation)).data
    tempDestinationPickup.value.pickupPointGuid = pickupPointsList[0].guid
    tempDestinationPickup.value.locationGuid = orderStore.destinationLocation.guid.toString()
    tempDestinationPickup.value.direction = 'pickupPoint'

    const resTimeTable = await getTimeTable({
      dispatch:
        {
          locationGuid: orderStore.dispatchLocation.guid,
          date: formatDate(orderStore.orderForm.directions.dispatch.calendar.date, 'YYYY-MM-DD')
        },
      destination:
        {
          locationGuid: tempDestinationPickup.value.locationGuid,
          pickupPointGuid: tempDestinationPickup.value.pickupPointGuid
        }
    })

    const tempOrderForm = deepCopyObject(orderStore.orderForm)
    tempDestinationPickup.value.calendar.date = resTimeTable.destination?.[0].dates?.[0].date || dayjs().format('YYYY-MM-DD')
    tempOrderForm.directions.destination = tempDestinationPickup.value

    const res = await getOrderPriceApi(pricePayload(tempOrderForm));

    pupTotalPrice.value = res?.cost?.total || 0
  } catch (e) {
    pupTotalPrice.value = 0
    console.error('ERROR, Не удалось рассчитать выгоду для ПВЗ Яндекс', e)
  }
}

async function addressGetPrice() {
  try {
    tempDestinationPickup.value.pickupPointGuid = ''
    tempDestinationPickup.value.locationGuid = orderStore.destinationLocation.guid.toString()
    tempDestinationPickup.value.direction = 'address'

    const resTimeTable = await getTimeTable({
      dispatch:
        {
          locationGuid: orderStore.dispatchLocation.guid,
          date: formatDate(orderStore.orderForm.directions.dispatch.calendar.date, 'YYYY-MM-DD')
        },
      destination:
        {
          locationGuid: tempDestinationPickup.value.locationGuid,
        }
    })

    const tempOrderForm = deepCopyObject(orderStore.orderForm)
    tempDestinationPickup.value.calendar.date = resTimeTable.destination?.[0].dates?.[0].date || dayjs().format('YYYY-MM-DD')
    tempOrderForm.directions.destination = tempDestinationPickup.value

    const res = await getOrderPriceApi(pricePayload(tempOrderForm));

    addressTotalPrice.value = res?.cost?.total || 0
  } catch (e) {
    addressTotalPrice.value = 0
    console.error('ERROR, Не удалось получить прайс до адреса', e)
  }
}

watch(() => [orderStore.orderForm.totalPrice], async () => {
  if ((orderStore.destinationLocation?.pup_count || 0) > 0 && !isTerminalDirection.value) {
    isLoadPupButton.value = true
    if (isPickupPoint.value) {
      await addressGetPrice()
      isLoadPupButton.value = false
      return
    }

    await yandexGetPrice()
    isLoadPupButton.value = false
  }
}, {immediate: true})

watch(() => orderStore.destinationLocation.guid, (val) => {
  if (val) {
    pupTotalPrice.value = 0
    addressTotalPrice.value = 0
  }
})
</script>

<style lang="scss" scoped>
.vz-pup-icon {
  &-yandex {
    background: #FC3F1D;
    border-radius: 20px;
  }

  &-location {
    margin-left: -2px;
    margin-top: -2px;
  }
}

.vz-order-total-price {
  &-links {
    @container (max-width: 390px) {
      display: none;
    }
  }

  &-print {
    @container (max-width: 315px) {
      display: none;
    }
  }
}
</style>
